<template lang="pug">
    v-container( fluid fill-height pa-0 class="overflow-hidden align-start  " )
        v-row(no-gutters)
            v-col
                v-row( no-gutters class="tw-bg-blue-800 tw-rounded-t py-2 pl-2")
                    v-col
                        span(class="white--text tw-font-medium ") Create Opportunity
                v-row( no-gutters  class=" fill-height grey lighten-4 tw-shadow-inner")
                    v-col(class="pa-2 mt-2" id="createOpportunity")
                        v-form(ref="opportunity" v-model="opportunity")
                            v-text-field(dense :rules="nameRules"  hide-details="auto" outlined background-color="white" color="indigo darken-1" v-model="name" label="Name"  required class="pb-2")
                            v-textarea(dense :rules="descriptionRules"  hide-details="auto" outlined background-color="white" color="indigo darken-1"  v-model="description" rows="3" no-resize  label="Description" required class="pb-2 pt-0")
                            v-autocomplete(dense hide-details="auto" outlined  background-color="white" color="indigo darken-1"  v-model="campaign" :items="campaigns" filled item-text="name" item-value="crm_id" clearable  label="Campaign" class="pt-0 pb-2" )
                            v-autocomplete(dense hide-details="auto" outlined background-color="white" color="indigo darken-1" v-model="assignTo" :items="staff" item-text="name" item-value="crmid" label="Assign to" clearable class="pt-0 pb-2")

        v-row( no-gutters class="align-self-end tw-bg-white tw-border tw-rounded-b"   )
                    v-col( class=" tw-text-right mx-2")
                        v-btn( small bottom retain-focus-on-click  @click="cancel" text) Cancel
                        v-btn(  depressed retain-focus-on-click   @click="createOpportunity" color="indigo darken-1" class="white--text" ) Create
        
        // Dialogs
        v-dialog( v-model="loading" persistent no-click-animation )
            v-card( color="primary")
                v-card-text(class=" pt-2 pb-2 tw-pl-2 tw-text-sm white--text text--accent-5 ") Hold tight...
                v-progress-linear(indeterminate color="white")
        
        v-dialog(v-model="success" persistent no-click-animation @click:outside="closeSuccess()" )
            v-card( color="green lighten-1" :ripple="false" @click="closeSuccess()"  )
                v-row(align="center" justify="center")
                    v-col(cols="auto")
                        div( class="tw-text-lg tw-font-medium white--text text--lighten-4")
                            |Got it!
                        div( class=" tw-text-center")
                            v-icon(color="white" x-large class="tw-align-center" ) mdi-check-circle-outline

        v-dialog(v-model="error" persistent no-click-animation @click:outside="closeError()" )
            v-card( color="red lighten-1" @click="closeError" :ripple="false"  )
                v-row(align="center" justify="center")
                    v-col(cols="auto")
                        div( class="tw-text-lg tw-font-medium white--text text--lighten-4")
                            |oops, sorry!
                        div( class=" tw-text-center tw-leading-none")
                            v-icon(color="white" x-large class="tw-align-center" ) mdi-crown
                        div( class=" tw-text-center tw-text-sm white--text tw-font-semibold tw-leading-none tw-tracking-widest")
                            |KEEP <br> CALM
                        div( class="tw-text-center tw-text-xs white--text tw-leading-tight")
                           |AND
                        div( class="tw-text-center tw-text-sm white--text tw-font-semibold tw-leading-none tw-tracking-widest")
                            |TRY <br>AGAIN

</template>
<script>
export default {
    data(){
        return{
            valid: false,
            ticket_body: '',
            name: '',
            description: '', 
            campaign: '',
            assignTo: '',
            campaigns: [],
            staff: [],
            loading: false,
            success: false,
            error: false,
            opportunity: false,
            nameRules: [
                v => !!v || 'We need to give it a name', 
                v => v && v.length >= 3 || "Let's give it a good name",
            ],
            descriptionRules: [
                v => !!v || 'We need a description',
                v => v && v.length >= 20 || "Elaborate a bit more",
            ]
        }
    },
    created() {
    },
    mounted() {
        this.getCampaign();
        this.getCampaignList();
        this.getStaffList();
    },
    methods: {
        getCampaign(){
            this.$zd.get('ticket.comments')
                .then(response => {
                    this.ticket_body = JSON.stringify(response['ticket.comments'].pop().value)
                    const headers = {
                        'Content-Type': 'application/json',
                        'OAuth-Token': this.$store.getters.token 
                    }
                    this.$http.post(this.$api_url + 'campaigns/find_campaign_code', {
                        body: this.ticket_body,
                    }, { headers: headers } )
                    .then(response =>{
                        this.campaign = response.data.crm_id
                    })
                    .catch(error => {
                        console.log(error)
                        if (error === 401) {
                            this.$router.push('/logout')
                        }
                    })                                          
                })
                .catch( error => {
                    console.log(error)
                })            
        },

        getCampaignList(){
            this.$http.get(this.$api_url + 'campaigns/list_active', {
            headers: {
                    'OAuth-Token': this.$store.getters.token
                }
            })
            .then(response => {
                this.campaigns = response.data
            })
            .catch(error => {
                if (error == 401) {
                    this.$router.push('/logout')
                }
            })
        },

        getStaffList(){
            this.$http.get(this.$api_url + 'sales-staff', {
            headers: {
                'OAuth-Token': this.$store.getters.token
                }
            })
            .then(response => {
                this.staff = response.data
            })
            .catch(error => {
                if(error == 401){
                    this.$router.push('/logout')
                }
            })
        },

        createOpportunity() {
            if (this.$refs.opportunity.validate()){
                this.loading = true,
                this.$http.post(this.$api_url + 'sugar/create', {
                    token: this.$store.getters.token,
                    record_type: 'Opportunities',
                    body: {
                        assigned_user_id: this.assignTo,
                        name: this.name,
                        description: this.description,
                        campaign_id: this.campaign,
                        account_id: this.$route.params.requester.company.idcrm,
                        date_closed: this.$moment().add(30, 'days').format('YYYY-MM-DD'),
                        amount: 0
                    
                    }
                })
                .then(response => {
                    console.log(response)
                    this.opportunity_crm_id = response.data.id
                    this.$zd.get('ticket')
                    .then(response =>{
                        this.ticket_no = response['ticket'].id
                        const headers = {
                        'Content-Type': 'application/json',
                        'OAuth-Token': this.$store.getters.token 
                        }
                        this.$http.post(this.$api_url + 'ticket/update', {
                            number: response['ticket'].id,
                            received_on: this.$moment(response['ticket'].createdAt).format(),
                            last_updated: this.$moment(response['ticket'].updatedAt).format(),
                            status: response['ticket'].status,
                            campaign_crmid: this.campaign,
                            requester_name: this.$route.params.requester.name,
                            requester_cpid: this.$route.params.requester.contactperson.ID,
                            requester_cid: this.$route.params.requester.company.id,
                            user_id: response['created_by'],
                            is_commercial: 1,
                        }, { headers: headers } )
                        .then(response =>{
                            this.$http.post(this.$api_url + 'opportunity/update',{
                                name: this.name,
                                campaign_crm_id: this.campaign_id,
                                user_crm_id: this.assignTo,
                                ticket: this.ticket_no,
                                status: 'Prospecting',
                                crm_id: this.opportunity_crm_id,
                                amount: 0
                            }, {headers: headers})
                            .then(response => {
                                this.loading = false
                                this.success = true
                                this._.delay( wait => {
                                    this.success = false
                                    this.$router.go(-1)
                                }, 3000)
                            })
                            .catch(error => {
                                console.log(error)
                                this.loading = false
                                this.error = true
                            })
                            
                        })
                        .catch(error=> {
                            console.log(error)
                            this.loading = false
                            this.error = true
                        })
                    })
                    .catch(error => {
                        console.log(error)
                        this.loading = false
                        this.error = true
                    })
                })
                .catch(error => {
                    console.log(error),
                    this.loading = false
                    this.error = true
                })
            }
        },

        closeSuccess(){
            this.success = false
            this.$router.go(-1)
        },

        closeError(){
            this.error = false
        },

        cancel(){
            this.$router.go(-1)
        }
    },
}
</script>
<style lang="stylus">
.v-btn:before {
  display: none;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 0px;
    margin: 0px;

}
#createOpportunity .v-application .py-2 {
    padding-top: 0px !important;
}
</style>